import { useAppSelector } from 'app/hooks';
import useGame from 'hooks/useGame';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectGameOdds } from 'redux/gameSlice';
import BetBody from './BetBody';
import BetForm from './BetForm/BetForm';

interface HomeMainWrapperProps {}

const HomeMainWrapper: React.FunctionComponent<HomeMainWrapperProps> = (props) => {
  const [searchParams] = useSearchParams();
  const odds = useAppSelector(selectGameOdds);

  const category = useMemo((): string | null => {
    return searchParams.get('category');
  }, [searchParams]);

  const rawTab = useMemo((): string | null => {
    return searchParams.get('tab');
  }, [searchParams]);

  const tab = useMemo((): string | null => {
    return rawTab;
  }, [category, rawTab]);

  const { isLoading } = useGame({
    league: tab || 'EPL',
  });

  return (
    <>
      <div className="body-main-page">
        <BetBody isLoading={isLoading} />
        <BetForm />
      </div>
    </>
  );
};

export default HomeMainWrapper;
